import DialogName from '../constants/DialogName';
import hideDialog from './hideDialog';

export default function hideDeleteFeatureConfirm() {
  return hideDialog(DialogName.DELETE_FEATURE_CONFIRM)();
}
